import React from "react";
import WeeklyTable from "./WeeklyTable";

export default function CashTable({ rows, setRows }) {
  return (
    <WeeklyTable
      title="Company / Driver Cash Trips (Week-wise)"
      rows={rows}
      setRows={setRows}
    />
  );
}
